import React from 'react'
import styled from '@emotion/styled'
import ThemeSelector from 'src/components/ThemeSelector'
import { util } from 'src/styles'

const SectionWrapper = styled(ThemeSelector)`
	position: relative;
	z-index: ${ ({ zIndex }) => zIndex };
	${ ({ padded, prevTheme, nextTheme, setTheme, isFirstSection }) => padded !== false && `
		${ !isFirstSection ? `
			${ setTheme === prevTheme ? `
				${ util.responsiveStyles('padding-top', 50, 28, 26, 26) }
			` : `
				${ util.responsiveStyles('padding-top', 100, 56, 52, 52) }
			` }
		` : `
			${ setTheme === 'default' ? `
				${ util.responsiveStyles('padding-top', 50, 28, 26, 26) }
			` : `
				${ util.responsiveStyles('padding-top', 100, 56, 52, 52) }
			` }
		` }
		${ setTheme === nextTheme ? `
			${ util.responsiveStyles('padding-bottom', 50, 28, 26, 26) }
		` : `
			${ util.responsiveStyles('padding-bottom', 100, 56, 52, 52) }
		` }
	` }
`

const Section = ({
	children,
	setTheme,
	prevTheme,
	nextTheme,
	zIndex,
	buttons,
	padded,
	sectionid,
	className,
  isFirstSection,
  overlayTextColor
}) => {
	return (
		<SectionWrapper
			className={className}
      setTheme={setTheme}
      overlayTextColor={overlayTextColor}
			prevTheme={prevTheme}
			nextTheme={nextTheme}
			zIndex={zIndex}
			padded={padded}
			isFirstSection={isFirstSection}
		>
			{children}
		</SectionWrapper>
	)
}

Section.defaultProps = {
	setTheme: 'bgColor',
	prevTheme: false,
	nextTheme: false,
	zIndex: 1,
	padded: true
}

export default Section
